<template>
  <div class="invite-detail">
    <AppNavBar title="邀请进度" :placeholder="true" :options="options">
    </AppNavBar>
    <div class="invite-container" v-if="activityConfig">
      <img
        class="detail-bg"
        :src="activityConfig.invite_schedule_image"
        alt=""
      />
      <div class="invite-wrapper">
        <div class="invite-top">
          <div v-if="prizeList.length">
            <div class="detail-title-container"
              ><div class="detail-title">我的奖品</div></div
            >
            <div class="my-prize-container">
              <div class="prize-scroll">
                <div class="prize-list">
                  <img
                    class="prize-item"
                    @click="bindJumpPrize(item)"
                    v-for="(item, index) in prizeList"
                    :key="index"
                    :src="item.img"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="detail-title-container"
            ><div class="detail-title">邀请明细</div></div
          >
          <div class="tips"
            >*好友加入正价营一周后，您和好友都将获得100元返现</div
          >
        </div>
        <div>
          <van-list
            v-if="inviteRecord.length"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getInviteProgress"
          >
            <div class="invite-list">
              <div
                class="invite-item"
                v-for="(item, index) in inviteRecord"
                :key="index"
              >
                <div class="item-top">
                  <div class="item-nickname">{{ item.invited_nickname }}</div>
                  <div class="item-phone">{{ item.invited_phone }}</div>
                  <!-- <div class="item-success" v-if="item.product_state"
                    >邀请返现已发放</div> -->
                </div>
                <div class="status-list">
                  <div
                    class="status-item"
                    :class="{ 'status-item-active': item.is_add_accompany }"
                  >
                    <div class="status-text">加陪伴官</div>
                    <div class="status-time" v-if="item.accompany_created_at">{{
                      item.accompany_created_at | fliterTime
                    }}</div>
                  </div>
                  <div
                    class="status-item"
                    :class="{ 'status-item-active': item.trial_product_state }"
                  >
                    <div class="status-text">参加体验营</div>
                    <div
                      class="status-time"
                      v-if="item.trial_product_created_at"
                      >{{ item.trial_product_created_at | fliterTime }}</div
                    >
                  </div>
                  <div
                    class="status-item"
                    :class="{ 'status-item-active': item.product_state }"
                  >
                    <div class="status-text">加入正式营</div>
                    <div class="status-time" v-if="item.product_created_at">{{
                      item.product_created_at | fliterTime
                    }}</div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
          <div class="empty-container" v-if="loaded && !inviteRecord.length">
            <img
              class="empty-image"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/450ae7ef590773964e7ca42a994b2e35.png"
              alt=""
            />
            <div class="e-title">您暂无邀请的好友哦！</div>
            <div class="e-desc">赶快点击下方按钮邀请好友一起加入吧～</div>
            <div class="e-btn" @click="handleShowShare">立即邀请好友</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />
  </div>
</template>

<script>
import AppNavBar from '@/components/app/nav-bar/index.vue'
import ShareComponent from '@/components/app/share/share.vue'
import { eventObj, defultIcons } from '@/components/app/share/share-method.js'
export default {
  components: { AppNavBar, ShareComponent },
  data() {
    return {
      activityConfig: null,
      options: {},
      showShare: false,
      shareOptions: {
        desc: '接收邀请，开启减脂之旅！',
        title: '赠送您3日真人营养师指导',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png' // 分享的缩略图的url
      },
      iconList: defultIcons,
      prizeList: [],
      inviteRecord: [],
      page: 1,
      finished: false,
      loading: false,
      loaded: false
    }
  },
  filters: {
    fliterTime(num) {
      let time = new Date(num * 1000)
      let month = time.getMonth() + 1
      let days = time.getDate()
      return (
        (month <= 9 ? '0' + month : month) +
        '-' +
        (days <= 9 ? '0' + days : days)
      )
    }
  },
  computed: {
    qrcodeUrl() {
      let uid =
        (this.$store.state.userInfo &&
          this.$store.state.userInfo.user &&
          this.$store.state.userInfo.user.uid) ||
        0
      let avatar =
        (this.$store.state.userInfo &&
          this.$store.state.userInfo.user &&
          this.$store.state.userInfo.user.head_img) ||
        ''
      let nickname =
        (this.$store.state.userInfo &&
          this.$store.state.userInfo.user &&
          this.$store.state.userInfo.user.truename) ||
        ''
      return `${
        location.origin
      }/camp-invite-v4/invite?uid=${uid}&avatar=${encodeURIComponent(
        avatar
      )}&nickname=${nickname}`
    }
  },
  created() {
    this.getActivityConfig()
    this.getInviteProgress()
    this.getPrizeList()
  },
  methods: {
    bindJumpPrize(item) {
      this.$betterwe.jumpRoute(item.route)
    },
    bindCancel() {
      this.showShare = false
    },
    handleShowShare() {
      this.showShare = true
    },
    async getInviteProgress() {
      let params = {
        page: this.page,
        page_size: 10
      }
      let res = await this.$http
        .getApp('api/v1/Introduction/getInviteProcess', params)
        .catch(() => {
          this.finished = true
        })
      this.loading = false
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data?.data.length) {
            this.page++
            this.inviteRecord = this.inviteRecord.concat(res.data.data)
          } else {
            this.finished = true
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getPrizeList() {
      let params = {
        page: 1,
        page_size: 20
      }
      let res = await this.$http
        .getApp('api/v1/Introduction/getPrizeList', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.prizeList = res.data?.data || []
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      let name =
        this.$store.state.userInfo.user &&
        this.$store.state.userInfo.user.truename
      shareOptions.title = name + '赠送您3日真人营养师指导'
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    async getActivityConfig() {
      let res = await this.$http
        .getApp('api/v1/Introduction/config', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.activityConfig = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.invite-detail {
  min-height: 100vh;
  background: #def0ff;
  .invite-container {
    position: relative;
    overflow: hidden;
    z-index: 0;
    .detail-bg {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .invite-wrapper {
      padding: 0px 12px;
      margin-top: 154px;
      .invite-top {
        margin-bottom: 13px;
        text-align: center;
        .my-prize-container {
          margin-bottom: 30px;
          background: #ffffff;
          border-radius: 8px;
          .prize-scroll {
            overflow-x: scroll;
            .prize-list {
              padding: 20px 35px;
              display: inline-flex;
              align-items: center;
              .prize-item {
                width: 80px;
                height: 101px;
                object-fit: contain;
                margin-right: 20px;
              }
              .prize-item:last-child {
                margin-right: 0;
              }
            }
          }
        }
        .detail-title-container {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 8px;
          .detail-title {
            position: relative;
            font-family: MiSans, MiSans;
            font-weight: bold;
            font-size: 18px;
            color: #303038;
            line-height: 26px;
          }
          .detail-title::before {
            content: '';
            position: absolute;
            width: 78px;
            height: 0.5px;
            background-color: rgba(0, 0, 0, 0.3);
            left: -12px;
            top: 50%;
            transform: translate(-100%, -50%);
          }
          .detail-title::after {
            content: '';
            position: absolute;
            width: 78px;
            height: 0.5px;
            background-color: rgba(0, 0, 0, 0.3);
            right: -12px;
            top: 50%;
            transform: translate(100%, -50%);
          }
        }
        .tips {
          font-size: 11px;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
        }
      }
      .invite-list {
        .invite-item {
          background: #ffffff;
          border-radius: 8px;
          padding: 12px 20px 18px;
          margin-bottom: 10px;
          .item-top {
            display: flex;
            align-items: center;
            margin-bottom: 19px;
            .item-nickname {
              font-size: 15px;
              color: #303038;
              line-height: 21px;
              margin-right: 13px;
              max-width: 200px;
            }
            .item-phone {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              font-size: 12px;
              color: #303038;
              line-height: 17px;
            }
            .item-success {
              font-size: 10px;
              color: #303038;
              line-height: 14px;
            }
          }
          .status-list {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            .status-item {
              display: flex;
              align-items: center;
              flex-direction: column;
              .status-text {
                width: 87px;
                height: 34px;
                background: #f1f1f1;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 12px;
                color: rgba(48, 48, 56, 0.7);
              }
              .status-time {
                margin-top: -4px;
                padding: 0px 5px;
                background: #f3be5e;
                border-radius: 8px;
                font-size: 10px;
                color: #ffffff;
                line-height: 15px;
              }
            }
            .status-item-active {
              .status-text {
                background: #ffefc8;
                color: #303038;
              }
            }
          }
        }
      }
      .empty-container {
        padding: 18px 0px 36px;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .empty-image {
          width: 214px;
          height: 112px;
          object-fit: contain;
          margin-bottom: 20px;
        }
        .e-title {
          font-family: MiSans, MiSans;
          font-weight: bold;
          font-size: 18px;
          color: #303038;
          line-height: 26px;
          margin-bottom: 4px;
        }
        .e-desc {
          font-size: 12px;
          color: rgba(48, 48, 56, 0.7);
          line-height: 17px;
          margin-bottom: 25px;
        }
        .e-btn {
          width: 240px;
          height: 44px;
          line-height: 44px;
          background: #ff2873;
          border-radius: 22px;
          font-weight: bold;
          text-align: center;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
